// @flow
import * as React from 'react';

import { useRouter } from 'next/router';
import { nextRoutes } from '@i18n';

import { StyledPagination, StyledReactPaginate, StyledPaginateWrapper } from './styles';

const Pagination = ({
  numberOfPages,
  setPage,
  className,
  initialPage
}: {
  numberOfPages: number,
  setPage: (pageNumber: number) => void,
  className?: string,
  initialPage: number
}): React.Node => {
  const router = useRouter();

  if (numberOfPages < 2) {
    return null;
  }

  const { nextRoute, ...restRouterQueryParams } = router.query;
  const { locale } = nextRoutes;

  return (
    <StyledPagination className={className}>
      <StyledPaginateWrapper pageCount={numberOfPages} initialPage={initialPage}>
        <StyledReactPaginate
          previousLabel=""
          nextLabel=""
          breakLabel="..."
          breakClassName="break-me"
          pageCount={numberOfPages}
          initialPage={initialPage}
          disableInitialCallback
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={({ selected }) => setPage(selected + 1)}
          subContainerClassName="pages pagination"
          activeClassName="active"
          hrefBuilder={page =>
            nextRoutes.findAndGetUrls(nextRoute, locale, {
              ...restRouterQueryParams,
              pageNumber: page
            }).urls.as}
        />
      </StyledPaginateWrapper>
    </StyledPagination>
  );
};

export default Pagination;
